import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class AppointmentCategoriesRecord extends RecordBase {

  static defaultAttributes = {
    name:                      '',
    tags:                      [],
    created_at:                '',
    updated_at:                '',
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    const trAttr = (attr) => t(`appointmentCategories.attributes.${attr}`);
    if(!this._attributeNames){
      this._attributeNames = {
        name:        trAttr('name'),
        tags:        trAttr('tags'),
        created_at:  trAttr('created_at'),
        updated_at:  trAttr('updated_at'),
      };
    }

    return this._attributeNames;
  }

  toParams(attrs={}){
    const {
      name,
      tags,
      created_at,
      updated_at,
    } = this.toObject();

    let tagsIds = [];
    if(tags) {
      tagsIds = tags.map(item => {
        return item.id;
      });
    }

    return {
      data:{
        attributes:{
          name,
          tags: tagsIds,
          created_at,
          updated_at,
          ...attrs
        }
      }
    };
  }
}
